<mat-icon
  (mouseover)="loadImage()"
  [matTooltipDisabled]="!groove"
  #tooltip="matTooltip"
  matTooltip="."
  [class]="matIconClassName ? matIconClassName : 's-16'">
  info_outline</mat-icon
>
